// extracted by mini-css-extract-plugin
module.exports = {"item":"timeline-module--item--1OArt","content":"timeline-module--content--2SXwa","icon":"timeline-module--icon--1V3fm","itemContainer":"timeline-module--item-container--2X-cr"};